import { FormlyFieldConfig } from '@ngx-formly/core';

export const DEFAULT_TABLE_CONFIG: ITableConfig = <ITableConfig>{
  title: '',
  grid: <ITableGridConfig>{
    showToolbar: true,
    showColumnMenu: true,
    columnResizable: false,
    paging: <ITablePagingConfig>{
      pageOnFront: true,
      pageIndex: 0,
      pageSize: 10,
      showPaginator: true,
    },
    filter: <ITableFilterConfig>{
      filterOnFront: true,
      sortOnFront: true,
      filterOptions: {},
    },
    select: <ITableSelectConfig>{
      rowSelectable: false,
      multiSelectable: false,
    },
  },
};

export interface ITableData {
  items: unknown[];
  itemsOriginal: unknown[];
  totalCount: number;
}

export interface ITableConfig {
  title: string;
  grid: ITableGridConfig;
}

export interface ITableGridConfig {
  showToolbar: boolean;
  showColumnMenu: boolean;
  columnResizable: boolean;
  paging: ITablePagingConfig;
  filter: ITableFilterConfig;
  select: ITableSelectConfig;
}

export interface ITablePagingConfig {
  pageOnFront: boolean;
  pageIndex: number;
  pageSize: number;
  showPaginator: boolean;
}

export interface ITableFilterConfig {
  sortOnFront: boolean;
  filterOnFront: boolean;
  filterFields?: FormlyFieldConfig[];
  filterOptions: any;
}

export interface ITableSelectConfig {
  rowSelectable: boolean;
  multiSelectable: boolean;
}
